import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@/modules/common/components/Paper';
import Error from '@/modules/common/components/Error';
import Content from '@/modules/common/components/Content';
import ContentBody from '@/modules/common/components/ContentBody';

const NotFound = () => {
    return (
        <Content id="404">
            <ContentBody><Paper>
                <Error>
                    <Typography>Страница не найдена.</Typography>
                </Error>
            </Paper></ContentBody>
        </Content>
    );
};

export default NotFound;
